import L from 'leaflet';
export var colors = ['#2196F3', '#CDDC39', '#d2190b', '#607D8B', '#af94e8', '#795548', '#FFEB3B', '#ace4fe', '#2830C9', '#009688', '#F44336', '#e0e0e0', '#673AB7', '#D39C11', '#9927C9', '#2E8938', '#FFC107', '#02BCD4', '#511414', '#F906CB', '#5B96FF', '#2b387c', '#8BC34A', '#ffb8a2', '#d1d077', '#f4df96'];
export var colorsPOI = {
  selected: '#FF8200',
  noSelected: '#9E9E9E',
  visited: '#ffb466',
  parking: '#005FD6'
};
export function getColor(color) {
  color = color || 0;
  return colors[color % colors.length] !== undefined ? colors[color % colors.length] : color;
}
export function createClusterCustomIcon(cluster) {
  var count = cluster.getChildCount();
  var size = 'LargeXL';

  if (count < 10) {
    size = 'Small';
  } else if (count >= 10 && count < 100) {
    size = 'Medium';
  } else if (count >= 100 && count < 1000) {
    size = 'Large';
  }

  var options = {
    cluster: "markerCluster".concat(size)
  };
  return L.divIcon({
    html: "<div>\n          <span class=\"markerClusterLabel markerClusterLabel".concat(size, "\">").concat(count, "</span>\n        </div>"),
    className: "".concat(options.cluster)
  });
}